export class MoovInstanceAbstractDTO{
    public id!: number;
    public customerId!: number;
    public sourceFileName!: string;
    public moovDefinitionName!: string;
    public added!: string;
}